<template>
    <div class="answer">
        <span v-html="answer.content"></span>
    </div>
</template>

<script>
export default {
    name: 'Answer',
    props: {
        answer: Object,
    },
}
</script>

<style lang="sass" scoped>
.answer
    padding: 10px
    font-weight: 400
    font-size: 14px
    line-height: 15px
    span
        display: inline-block
        overflow-wrap: break-word
        width: 100%
</style>
